/*
 *
 * Team constants
 *
 */

export const DEFAULT_ACTION = 'app/Team/DEFAULT_ACTION';

export const FETCH_TEAM = 'app/Team/FETCH_TEAM';
export const FETCH_TEAM_SUCCESS = 'app/Team/FETCH_TEAM_SUCCESS';
export const FETCH_TEAM_FAILURE = 'app/Team/FETCH_TEAM_FAILURE';

export const FETCH_TEAM_APPS = 'app/Team/FETCH_TEAM_APPS';
export const FETCH_TEAM_APPS_SUCCESS = 'app/Team/FETCH_TEAM_APPS_SUCCESS';
export const FETCH_TEAM_APPS_FAILURE = 'app/Team/FETCH_TEAM_APPS_FAILURE';

export const FETCH_SELECTED_APP_SUCCESS = 'app/Team/FETCH_SELECTED_APP_SUCCESS';
export const ASSIGN_TEAM_APP = 'app/Team/ASSIGN_TEAM_APP';
export const ASSIGN_TEAM_APP_SUCCESS = 'app/Team/ASSIGN_TEAM_APP_SUCCESS';
export const ASSIGN_TEAM_APP_FAILURE = 'app/Team/ASSIGN_TEAM_APP_FAILURE';

export const TOGGLE_ACTIVATE_TEAM_APP = 'app/Team/TOGGLE_ACTIVATE_TEAM_APP';
export const TOGGLE_ACTIVATE_TEAM_APP_SUCCESS =
  'app/Team/TOGGLE_ACTIVATE_TEAM_APP_SUCCESS';
export const TOGGLE_ACTIVATE_TEAM_APP_FAILURE =
  'app/Team/TOGGLE_ACTIVATE_TEAM_APP_FAILURE';

export const UPDATE_TEAM_APP = 'app/Team/UPDATE_TEAM_APP';
export const UPDATE_TEAM_APP_SUCCESS = 'app/Team/UPDATE_TEAM_APP_SUCCESS';
export const UPDATE_TEAM_APP_FAILURE = 'app/Team/UPDATE_TEAM_APP_FAILURE';

export const UPDATE_TEAM = 'app/Team/UPDATE_TEAM';
export const UPDATE_TEAM_SUCCESS = 'app/Team/UPDATE_TEAM_SUCCESS';
export const UPDATE_TEAM_FAILURE = 'app/Team/UPDATE_TEAM_FAILURE';

export const DELETE_TEAM = 'app/Team/DELETE_TEAM';
export const DELETE_TEAM_SUCCESS = 'app/Team/DELETE_TEAM_SUCCESS';
export const DELETE_TEAM_FAILURE = 'app/Team/DELETE_TEAM_FAILURE';

export const UNDELETE_TEAM = 'app/Team/UNDELETE_TEAM';
export const UNDELETE_TEAM_SUCCESS = 'app/Team/UNDELETE_TEAM_SUCCESS';
export const UNDELETE_TEAM_FAILURE = 'app/Team/UNDELETE_TEAM_FAILURE';

export const FETCH_TEAM_ASSESSMENTS = 'app/Team/FETCH_TEAM_ASSESSMENTS';
export const FETCH_TEAM_ASSESSMENTS_SUCCESS =
  'app/Team/FETCH_TEAM_ASSESSMENTS_SUCCESS';
export const FETCH_TEAM_ASSESSMENTS_FAILURE =
  'app/Team/FETCH_TEAM_ASSESSMENTS_FAILURE';

export const CREATE_ASSESSMENT = 'app/Team/CREATE_ASSESSMENT';
export const CREATE_ASSESSMENT_SUCCESS = 'app/Team/CREATE_ASSESSMENT_SUCCESS';
export const CREATE_ASSESSMENT_FAILURE = 'app/Team/CREATE_ASSESSMENT_FAILURE';

export const DELETE_ASSESSMENT = 'app/Team/DELETE_ASSESSMENT';
export const BULK_DELETE_ASSESSMENTS = 'app/Team/BULK_DELETE_ASSESSMENTS';
export const DELETE_ASSESSMENT_SUCCESS = 'app/Team/DELETE_ASSESSMENT_SUCCESS';
export const DELETE_ASSESSMENT_FAILURE = 'app/Team/DELETE_ASSESSMENT_FAILURE';

export const REFRESH_ASSESSMENT = 'app/Team/REFRESH_ASSESSMENT';
export const REFRESH_ASSESSMENT_SUCCESS = 'app/Team/REFRESH_ASSESSMENT_SUCCESS';
export const REFRESH_ASSESSMENT_FAILURE = 'app/Team/REFRESH_ASSESSMENT_FAILURE';

export const DOWNLOAD_TEAM_ASSESSMENT_DATA =
  'app/Team/DOWNLOAD_TEAM_ASSESSMENT_DATA';

export const IMPORT_ASSESSMENTS = 'app/Team/IMPORT_ASSESSMENTS';
export const IMPORT_ASSESSMENTS_SUCCESS = 'app/Team/IMPORT_ASSESSMENTS_SUCCESS';
export const IMPORT_ASSESSMENTS_FAILURE = 'app/Team/IMPORT_ASSESSMENTS_FAILURE';

export const FETCH_IMPORTED_ASSESSMENTS = 'app/Team/FETCH_IMPORTED_ASSESSMENTS';
export const FETCH_IMPORTED_ASSESSMENTS_SUCCESS =
  'app/Team/FETCH_IMPORTED_ASSESSMENTS_SUCCESS';
export const FETCH_IMPORTED_ASSESSMENTS_FAILURE =
  'app/Team/FETCH_IMPORTED_ASSESSMENTS_FAILURE';

export const RESET_STATE = 'app/Team/RESET_STATE';
export const RESET_TEAM_WIDGETS = 'app/Team/RESET_TEAM_WIDGETS';
export const RESET_CUSTOM_FILTERS = 'app/Team/RESET_CUSTOM_FILTERS';

export const RESET_SECURITY_CODE = 'app/Team/RESET_SECURITY_CODE';
export const RESET_SECURITY_CODE_SUCCESS =
  'app/Team/RESET_SECURITY_CODE_SUCCESS';
export const RESET_SECURITY_CODE_FAILURE =
  'app/Team/RESET_SECURITY_CODE_FAILURE';

export const DISABLE_SECURITY_CODE = 'app/Team/DISABLE_SECURITY_CODE';
export const DISABLE_SECURITY_CODE_SUCCESS =
  'app/Team/DISABLE_SECURITY_CODE_SUCCESS';
export const DISABLE_SECURITY_CODE_FAILURE =
  'app/Team/DISABLE_SECURITY_CODE_FAILURE';

export const FETCH_TEAM_WIDGETS = 'app/Team/FETCH_TEAM_WIDGETS';
export const FETCH_TEAM_WIDGETS_SUCCESS = 'app/Team/FETCH_TEAM_WIDGETS_SUCCESS';
export const FETCH_TEAM_WIDGETS_FAILURE = 'app/Team/FETCH_TEAM_WIDGETS_FAILURE';

export const FETCH_WORKFLOW_GROUPS = 'app/Team/FETCH_WORKFLOW_GROUPS';
export const FETCH_WORKFLOW_GROUPS_SUCCESS =
  'app/Team/FETCH_WORKFLOW_GROUPS_SUCCESS';
export const FETCH_WORKFLOW_GROUPS_FAILURE =
  'app/Team/FETCH_WORKFLOW_GROUPS_FAILURE';

export const RESET_WORKFLOW_GROUPS = 'app/Team/RESET_WORKFLOW_GROUPS';

// TODO refactor: use Widgets actions/reducer/sagas instead
export const EXECUTE_TEAM_WIDGET = 'app/Team/EXECUTE_TEAM_WIDGET';
export const EXECUTE_TEAM_WIDGET_SUCCESS =
  'app/Team/EXECUTE_TEAM_WIDGET_SUCCESS';
export const EXECUTE_TEAM_WIDGET_FAILURE =
  'app/Team/EXECUTE_TEAM_WIDGET_FAILURE';

export const SET_CUSTOM_FILTERS = 'app/Team/SET_CUSTOM_FILTERS';

export const CHANGE_CURRENT_ASSIGNEE = 'app/Team/CHANGE_CURRENT_ASSIGNEE';
export const CHANGE_CURRENT_ASSIGNEE_SUCCESS =
  'app/Team/CHANGE_CURRENT_ASSIGNEE_SUCCESS';
export const CHANGE_CURRENT_ASSIGNEE_FAILURE =
  'app/Team/CHANGE_CURRENT_ASSIGNEE_FAILURE';

export const SEND_REMINDER = 'app/Team/SEND_REMINDER';
export const SEND_REMINDER_SUCCESS = 'app/Team/SEND_REMINDER_SUCCESS';
export const SEND_REMINDER_FAILURE = 'app/Team/SEND_REMINDER_FAILURE';

export const ASSIGN_WORKFLOW_GROUP_USERS =
  'app/Team/ASSIGN_WORKFLOW_GROUP_USERS';
export const ASSIGN_WORKFLOW_GROUP_USERS_SUCCESS =
  'app/Team/ASSIGN_WORKFLOW_GROUP_USERS_SUCCESS';
export const ASSIGN_WORKFLOW_GROUP_USERS_FAILURE =
  'app/Team/ASSIGN_WORKFLOW_GROUP_USERS_FAILURE';

export const SELECT_TEAM_WIDGET = 'app/Team/SELECT_TEAM_WIDGET';

export const DELETE_WORKFLOW_GROUP_USER = 'app/Team/DELETE_WORKFLOW_GROUP_USER';
export const DELETE_WORKFLOW_GROUP_USER_SUCCESS =
  'app/Team/DELETE_WORKFLOW_GROUP_USER_SUCCESS';
export const DELETE_WORKFLOW_GROUP_USER_FAILURE =
  'app/Team/DELETE_WORKFLOW_GROUP_USER_FAILURE';

export const SET_ASSESSMENT_IS_SENSITIVE =
  'app/Team/SET_ASSESSMENT_IS_SENSITIVE';
export const SET_ASSESSMENT_IS_SENSITIVE_SUCCESS =
  'app/Team/SET_ASSESSMENT_IS_SENSITIVE_SUCCESS';
export const SET_ASSESSMENT_IS_SENSITIVE_FAILURE =
  'app/Team/SET_ASSESSMENT_IS_SENSITIVE_FAILURE';

export const FETCH_TEAM_MEMBERSHIP = 'app/Team/FETCH_TEAM_MEMBERSHIP';
export const FETCH_TEAM_MEMBERSHIP_SUCCESS =
  'app/Team/FETCH_TEAM_MEMBERSHIP_SUCCESS';
export const FETCH_TEAM_MEMBERSHIP_FAILURE =
  'app/Team/FETCH_TEAM_MEMBERSHIP_FAILURE';

export const RESET_TEAM_ASSESSMENTS_STATE =
  'app/Team/RESET_TEAM_ASSESSMENTS_STATE';

// new solution related actions
export const FETCH_TEAM_SOLUTIONS = 'app/Team/FETCH_TEAM_SOLUTIONS';
export const FETCH_TEAM_SOLUTIONS_SUCCESS =
  'app/Team/FETCH_TEAM_SOLUTIONS_SUCCESS';
export const FETCH_TEAM_SOLUTIONS_FAILURE =
  'app/Team/FETCH_TEAM_SOLUTIONS_FAILURE';
export const ADD_TEAM_SOLUTION = 'app/Team/ADD_TEAM_SOLUTION';
export const ADD_TEAM_SOLUTION_SUCCESS = 'app/Team/ADD_TEAM_SOLUTION_SUCCESS';
export const ADD_TEAM_SOLUTION_FAILURE = 'app/Team/ADD_TEAM_SOLUTION_FAILURE';

export const FETCH_SOLUTIONS_PERMISSION = 'app/Team/FETCH_SOLUTIONS_PERMISSION';
export const FETCH_SOLUTIONS_PERMISSION_SUCCESS =
  'app/Team/FETCH_SOLUTIONS_PERMISSION_SUCCESS';
export const FETCH_SOLUTIONS_PERMISSION_FAILURE =
  'app/Team/FETCH_SOLUTIONS_PERMISSION_FAILURE';
